import React from 'react'
import { FiArrowRight, FiFacebook, FiInstagram, FiLinkedin, FiMail, FiMapPin, FiPhone, FiSend, FiTwitter } from 'react-icons/fi'
import Navbar from '../../@shared/navigations/default'

const ContactPage = () => {
    return (
        <React.Fragment>
            <title>Contact</title>
            <Navbar />
            <div id="contact">
                <div className="banner flex-column">
                    <h1 className='title'>Contact</h1>
                    <p className='description'>Need a help? We are available for hire!</p>
                    <div className="flex-center socials">
                    <div> <FiFacebook className='icon' /> </div>
                    <div> <FiTwitter className='icon' /> </div>
                    <div> <FiInstagram className='icon border' /></div>
                    <div> <FiLinkedin  className='icon' /></div>
                    </div>
                </div>
                
                <Information />
            <div className="switches">
                <Newsletter /> 
            </div>
            
            </div>
        </React.Fragment>
    )
}

export default ContactPage

const Information = () => {

    return (
        <div className='information flex'>
            <div className='address flex-column'>
                <div>
                    <ul>
                        <li>
                            <div className='icon'><FiMail /></div>
                            <div className='info'>
                                <div className='name'>Email</div>
                                <p>test@test.com</p>
                            </div>
                        </li>
                        <li>
                            <div className='icon'><FiMapPin /></div>
                            <div className='info'>
                                <div className='name'>Office</div>
                                <p>14 A Side Road, GreenGiven 36069  United States</p>
                            </div>
                        </li>
                        <li>
                            <div className='icon'><FiPhone /></div>
                            <div className='info'>
                                <div className='name'>Phone</div>
                                <p>0512 345 67 89</p>
                            </div>
                        </li>
                    </ul>
                    <p className='body'>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt quod, corporis, iste 
                        quia culpa maxime officia accusamus distinctio magni aliquid necessitatibus eos ipsum deleniti odio, 
                        porro ut itaque dignissimos perspiciatis.
                    </p>
                </div>
            </div>
            <div className='contact-form'>   
                <input type="text" name="email" placeholder='Email' />
                <input type="email" name="phone" placeholder='Phone' />
                <textarea name="message" id="message" placeholder='Message'></textarea>
                <div className='button'>Message</div>
            </div>
        </div>
    )
}

const Newsletter = () => {

    return (
        <div className='newsletter'>
            <div className='news'>
                <h3>Subscribe to our daily newsletter</h3>
                <div><FiArrowRight /></div>
            </div>
            <div className='subscription'>
                <div className="input">
                    <input type="text" name="news" placeholder='Subscription' />
                    <FiSend />
                </div>
                <p>Join our subscriber's list to get the latest updates 
                and articles delivered directly in your inbox </p>
            </div>
        </div>
    )
}

